var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/axios';
export function postAssessmentRating(assessmentId_1, _a) {
    return __awaiter(this, arguments, void 0, function* (assessmentId, { rating, reasonCode, details }) {
        yield api.post(`/api/internal/ia/inspection_assessments/${assessmentId}/rating`, {
            rating,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            reason_code: reasonCode !== null && reasonCode !== void 0 ? reasonCode : undefined,
            details: details !== null && details !== void 0 ? details : undefined
        });
    });
}
